<template>
	<div class="paginator-wrapper">
		<div class="paginator hidden-xs">
			<router-link v-if="showFirst" :to="baseUrl + query" class="l-rnd">&laquo;</router-link><template v-for="(page, idx) in pages">
				<router-link v-if="page !== curPage" :to="baseUrl + (page !== 1 ? '/' + page : '') + query" :class="whatClass(idx)" :key="'page-num-' + idx">{{ page }}</router-link>
				<span v-else :class="whatClass(idx)" :key="'page-num-active-' + idx">{{ page }}</span>
			</template><router-link v-if="showLast" :to="baseUrl + '/' + lastPage + query" class="r-rnd arr-last">&raquo;</router-link>
		</div>
		<div class="paginator visible-xs-inline">
			<router-link v-if="showMobileFirst" :to="baseUrl + query" class="l-rnd">&laquo;</router-link><router-link v-if="showPrev" :to="baseUrl + '/' + (curPage - 1) + query">&larr;</router-link><span>{{ curPage }}</span><router-link v-if="showNext" :to="baseUrl + '/' + (curPage + 1) + query">&rarr;</router-link><router-link v-if="showMobileLast" :to="baseUrl + '/' + lastPage + query" class="r-rnd arr-last">&raquo;</router-link>
		</div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'paginator',
	//=========================================================================
	props: ['baseUrl', 'pages', 'curPage', 'lastPage', 'queryString'],
	//=========================================================================
	computed: {
		//---------------------------------------------------------------------
		query() {
			if (this.queryString) {
				return this.queryString
			}
			return ''
		},
		//---------------------------------------------------------------------
		showFirst() {
			return !this.pages.some(i => {
				if (i === 1) return true
			})
		},
		//---------------------------------------------------------------------
		showMobileFirst() {
			return this.curPage > 1
		},
		//---------------------------------------------------------------------
		showLast() {
			return !this.pages.some(i => {
				if (i === this.lastPage) return true
			})
		},
		//---------------------------------------------------------------------
		showMobileLast() {
			return this.curPage < this.lastPage
		},
		//---------------------------------------------------------------------
		showPrev() { return this.curPage > 1 },
		//---------------------------------------------------------------------
		showNext() { return this.curPage < this.lastPage }
	},
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		whatClass(idx) {
			if (!this.showFirst && idx === 0) return 'l-rnd'
			if (!this.showLast && idx === (this.pages.length - 1)) return 'r-rnd'

			return false
		}
		//---------------------------------------------------------------------
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.paginator-wrapper {
	margin: 20px 0 40px 0;
}

.paginator {
	display: inline-block;
	margin-top: 10px;
}

.paginator > a,
.paginator > span {
	font-size: 80%;
    padding: 5px 10px;
    border-top: 1px solid #eee;
	border-bottom: 1px solid #eee;
	border-left: 1px solid #eee;
}

.paginator .arr-last {
	border-right: 1px solid #eee;
}

.paginator .l-rnd {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.paginator .r-rnd {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
	border-right: 1px solid #eee;
}

.paginator > a:focus,
.paginator > a:hover {
	background-color: #eee;
	color: #23527c;
}

.paginator > span,
.paginator > span:hover {
    background-color: #2c8ad8;
    border-color: #2c8ad8;
	color: white;
    user-select: none;
}

body.mc .paginator > span,
body.mc .paginator > span:hover {
    background-color: #01196f;
    border-color: #01196f;
	color: white;
    user-select: none;
}

.paginator span.r-rnd {
	border-right: none;
}

@media screen and (max-width: 767px) {
	.paginator-wrapper {
		margin: 90px 0 40px 0;
	}

	.paginator > a,
	.paginator > span {
		font-size: 100%;
	    padding: 8px 16px;
	}
}
</style>



// WEBPACK FOOTER //
// paginator.vue?4af53ffc